<div class="tw:bg-white tw:rounded-lg tw:shadow-lg tw:w-screen tw:md:w-md">
    @if (loading()) {
        <div class="tw:p-8">
            <app-loader />
        </div>
    } @else if (form) {
        <form [formGroup]="form" (ngSubmit)="submit()">
            @if (saving()) {
                <div class="tw:p-8">
                    <div class="tw:p-4">
                        <app-loader />
                    </div>

                    <div class="tw:text-center">
                        <div class="tw:text-sm tw:font-semibold">
                            {{ 'SHARED.SIMPLE_PAYMENT_MODAL.waitingPayment' | translate }}
                        </div>
                        <div class="tw:mt-0.5 tw:text-sm tw:text-neutral-500">{{ form.value.amount | merchantCurrency }}</div>
                    </div>
                </div>
                <div class="tw:flex tw:justify-center tw:gap-4 tw:border-t tw:border-neutral-200 tw:p-4">
                    <app-button type="secondary" size="sm" [disabled]="cancellingTeyaPayment()" (clickEvent)="cancelWaitingPayment()">
                        {{ 'GENERAL.cancel' | translate }}
                    </app-button>
                </div>
            } @else if (success()) {
                <div class="tw:px-8 tw:py-16 tw:flex tw:flex-col tw:justify-center tw:items-center">
                    <app-icon icon="check" [inCircle]="true" extraClass="tw:mb-2 tw:!text-success-500 tw:!bg-success-100 tw:!text-2xl" />
                    <div class="tw:text-center">
                        <div class="tw:text-sm tw:font-semibold">
                            {{ 'SHARED.SIMPLE_PAYMENT_MODAL.paymentReceived' | translate }}
                        </div>
                        <div class="tw:mt-0.5 tw:text-sm tw:text-neutral-500">{{ form.value.amount | merchantCurrency }}</div>
                    </div>
                </div>
                <div class="tw:flex tw:justify-center tw:gap-4 tw:border-t tw:border-neutral-200 tw:p-4">
                    <app-button type="primary" size="sm" (clickEvent)="close('success')">
                        {{ 'GENERAL.close' | translate }}
                    </app-button>
                </div>
            } @else if (failed()) {
                <div class="tw:px-8 tw:py-16 tw:flex tw:flex-col tw:justify-center tw:items-center">
                    <app-icon icon="close" [inCircle]="true" extraClass="tw:mb-2 tw:!text-error-500 tw:!bg-error-100 tw:!text-2xl" />
                    <div class="tw:text-center">
                        <div class="tw:text-sm tw:font-semibold">
                            {{ 'SHARED.SIMPLE_PAYMENT_MODAL.paymentFailed' | translate }}
                        </div>
                        <div class="tw:mt-2 tw:text-sm tw:text-neutral-500">
                            {{ errorMessage() || ('SHARED.SIMPLE_PAYMENT_MODAL.paymentFailedDescription' | translate) }}
                        </div>
                        <div class="tw:mt-2 tw:text-sm tw:font-semibold tw:text-neutral-500">{{ form.value.amount | merchantCurrency }}</div>
                    </div>
                </div>
                <div class="tw:flex tw:justify-center tw:gap-4 tw:border-t tw:border-neutral-200 tw:p-4">
                    <app-button type="secondary" size="sm" (clickEvent)="cancelFailure()">
                        {{ 'GENERAL.cancel' | translate }}
                    </app-button>
                    <app-button type="primary" size="sm" (clickEvent)="sendToTerminal()">
                        {{ 'GENERAL.retry' | translate }}
                    </app-button>
                </div>
            } @else {
                <div class="tw:p-8">
                    <div>
                        <h6 class="tw:h6">{{ 'SHARED.createInvoiceModal.terminalPay' | translate }}</h6>
                    </div>
                    <div>
                        <app-text-input [submitAttempted]="submitAttempted()"
                            inputType="number"
                            formControlName="amount"
                            label="{{ 'SHARED.SIMPLE_PAYMENT_MODAL.amountLabel' | translate }}"
                            placeholder="{{ 'SHARED.SIMPLE_PAYMENT_MODAL.amountPlaceholder' | translate }}"
                         />
                        @if (data.amount && form.get('amount')?.value * 100 !== data.amount) {
                            <p class="tw:text-xs tw:text-neutral-400">
                                {{ 'SHARED.SIMPLE_PAYMENT_MODAL.bookingAmount' | translate }}: {{ data.amount / 100 | merchantCurrency }}
                            </p>
                        }
                    </div>
                    <div class="">
                        <label>{{ 'SHARED.SIMPLE_PAYMENT_MODAL.method' | translate }}</label>
                        <button
                            type="button"
                            class="tw:border-primary-500 tw:bg-primary-500 tw:flex tw:w-full tw:items-center tw:gap-3 tw:!rounded-xl tw:border tw:px-4 tw:py-3 tw:text-left tw:text-sm tw:font-medium tw:text-white tw:transition-colors"
                        >
                            <app-icon icon="credit_card" [inCircle]="true" />

                            <span class="tw:min-w-0 tw:flex-1"
                                ><span class="block">{{ 'SHARED.SIMPLE_PAYMENT_MODAL.sendToTerminal' | translate }}</span
                                ><span class="tw:block tw:text-xs tw:font-normal tw:text-white/70">{{
                                    'SHARED.SIMPLE_PAYMENT_MODAL.teyaTerminal' | translate
                                }}</span></span
                            >

                            <app-icon icon="check" />
                        </button>
                    </div>

                    <!-- MOCK SWITCH FOR CLIENTS WITHOUT INVOICING -->
                     @if (!isInvoicingActive()) {
                         <div class="tw:border-neutral-200 tw:rounded-xl tw:border tw:px-4 tw:py-3 tw:mt-4">
                             <div class="tw:flex tw:items-center tw:justify-between tw:gap-3 tw:text-sm tw:font-medium tw:text-neutral-400">
                                 {{ 'SHARED.SIMPLE_PAYMENT_MODAL.invoiceTitle' | translate }}
                             </div>
                             <div class="tw:mt-1.5 tw:text-xs tw:text-neutral-400">
                                 {{ 'SHARED.SIMPLE_PAYMENT_MODAL.invoiceDescription' | translate }}
                                 <a class="tw:text-primary-600 tw:hover:text-primary-700 tw:font-medium" (click)="close()" routerLink="{{ currentStore()?.slug }}/dashboard/extensions/invoicing" data-discover="true"
                                     >{{ 'SHARED.SIMPLE_PAYMENT_MODAL.learnMore' | translate }}</a
                                 >
                             </div>
                         </div>
                     }
                </div>


                <div class="tw:flex tw:justify-center tw:gap-4 tw:border-t tw:border-neutral-200 tw:p-4">
                    <app-button [disabled]="saving()" type="secondary" size="sm" (clickEvent)="close()">
                        {{ 'GENERAL.cancel' | translate }}
                    </app-button>
                    <app-button [disabled]="saving()" buttonType="submit" size="sm">
                        {{ 'SHARED.SIMPLE_PAYMENT_MODAL.send' | translate }}
                    </app-button>
                </div>
            }
        </form>
    }
</div>
